import React, { createContext, useState } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [authData, setAuthData] = useState({ jwt: null, user: null });

    const login = (jwt, user) => {
        setAuthData({ jwt, user });
    };

    const logout = () => {
        setAuthData({ jwt: null, user: null });
    };

    return (
        <AuthContext.Provider value={{ authData, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
